module.exports = __webpack_public_path__ + "media/packs/images/flags/SA-fb041d9f5e4cfed78c6448979635e141.svg";